// A stable per-browser id, sent as `X-Device-Id`.
//
// Used only to key rate limits: account recovery is capped per device rather
// than per IP so that one person forgetting their password doesn't spend the
// budget for a whole office behind a single NAT address.
//
// ⚠️ NOT a security token. It is generated by the client and trivially forged,
// which is why the server still mixes the IP into the key. Nothing may be
// authorised on the strength of it.

const KEY = 'deviceId';

export function getDeviceId() {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    // `window`, not `globalThis` — CRA's eslint config targets a browser
    // environment that predates it, and it fails the build as `no-undef`.
    // randomUUID also needs a secure context, so the fallback keeps this
    // working on plain http in development rather than throwing.
    const id =
      (typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : null) ||
      `d-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    // Private browsing can refuse localStorage entirely. A per-tab id is still
    // better than none, and the server falls back to the IP anyway.
    return null;
  }
}
